/* eslint-disable react/prop-types */
import React from 'react';
import { Check, X } from 'lucide-react';

function ContentJoinWorkspacePopup({
  workspaceName,
  roleName,
  onAccept,
  onDecline,
}) {
  return (
    <div style={{
      width: 'calc(100vw - 10px)',
      maxWidth: '700px',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      height: '100%',
    }}
    >
      <h4 style={{
        padding: '10px',
        margin: '0px',
        width: '100%',
        display: 'flex',
        color: 'var(--very-visible)',
        boxSizing: 'border-box',
        fontSize: '14px',
        fontWeight: 500,
        letterSpacing: '.07em',
        borderBottom: '1px solid var(--main1Border)',
        height: '50px',
        alignItems: 'center',
      }}
      >
        Workspace invitation
      </h4>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '15px 10px',
      }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--visible)',
          fontSize: '0.95rem',
        }}
        >
          You have been invited to join
          <span style={{
            background: 'var(--special-color)',
            color: 'var(--very-visible)',
            borderRadius: '5px',
            padding: '2px 10px',
            fontWeight: 'bold',
          }}
          >
            {workspaceName}
          </span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--visible)',
          fontSize: '0.95rem',
        }}
        >
          Role:
          <span style={{
            background: 'var(--main1)',
            border: '1px solid var(--main1Border)',
            color: 'var(--visible)',
            borderRadius: '5px',
            padding: '2px 10px',
          }}
          >
            {roleName}
          </span>
        </div>
      </div>
      <div style={{
        height: '55px',
        width: '100%',
        borderTop: '1px solid var(--main1Border)',
        boxSizing: 'border-box',
        padding: '10px',
        display: 'flex',
        justifyContent: 'end',
        gap: '8px',
        marginTop: 'auto',
      }}
      >
        <button
          type="button"
          onClick={onDecline}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '6px 14px',
            borderRadius: '5px',
            border: '1px solid rgb(253, 103, 92)',
            background: 'none',
            color: 'rgb(253, 103, 92)',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          Decline
          <X size={16} />
        </button>
        <button
          type="button"
          onClick={onAccept}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '6px 14px',
            borderRadius: '5px',
            border: '1px solid var(--special-color)',
            background: 'none',
            color: 'var(--special-color)',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          Accept
          <Check size={16} />
        </button>
      </div>
    </div>
  );
}

export default ContentJoinWorkspacePopup;
